<script>
import 'vuetify/dist/vuetify.min.css';
import '@src/design/ck-editor-content-styles.css';
import JwFomResponseItem from "@components/JwFomResponseItem";
import {appConfig} from '@src/config';

export default {
  name: 'App',

  components: {
    JwFomResponseItem
  },

  data: () => ({
    logoUrl: null,
    companyName: null,
    isLoading: true,
    companyId: true,
  }),
  methods: {
    goHome() {
      document.location.href = appConfig.baseHomeUrl;
    },
    changeCompanyInfo(info) {
      this.logoUrl = info?.images?.logoForm?.url || null;
      this.companyName = info?.name || null;
      this.companyId = info?.id || null;
    },
    finishLoading() {
      this.isLoading = false;
    }
  }
};
</script>

<template>
  <VApp class="app-page">
    <div class="brandBox">
      <div class="brandContainer">
        <div class="logo">
          <img v-if="logoUrl && !isLoading" class="imgBrand jwCursorPointer" :src="logoUrl" alt="" @click="goHome()">
          <img v-else-if="companyId==='volan' && !isLoading" class="imgBrand jwCursorPointer" :src="require('@assets/images/logo-main.png')" alt="" @click="goHome()">
          <div v-else class="imgBrand jwCursorPointer"  alt="" @click="goHome()"></div>
        </div>
        <div v-if="companyId!=='volan' && !isLoading" class="textContainer">
          <div class="companyName">{{companyName}}</div>
          <div class="poweredBy">
            <img class="poweredByImg jwCursorPointer" :src="require('@assets/images/poweredbyvolan@3x.png')" alt="" @click="goHome()">
          </div>
        </div>
      </div>
    </div>
    <div class="content">
      <JwFomResponseItem
          @changeCompanyInfo="changeCompanyInfo"
          @finishLoading="finishLoading"
      ></JwFomResponseItem>
    </div>
  </VApp>
</template>

<style lang="scss">

html {
  overflow-y: auto;
  background-color: #0a0a0a !important;
}

body {
  background-color: #0a0a0a !important;
}

* {
  scrollbar-width: thin;
  scrollbar-color: var(--v-scroll-base, #5a5a5a) var(--v-scrollBg-base, #121212);
}

/* Works on Chrome/Edge/Safari */
*::-webkit-scrollbar {
  width: 7px;
}
*::-webkit-scrollbar-track {
  background: var(--v-scrollBg-base, #121212);
}
*::-webkit-scrollbar-thumb {
  background-color: var(--v-scroll-base, #5a5a5a);
  border-radius: 20px;
  // border: 3px solid #121212;
}


.jwCursorPointer {
  cursor: pointer;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.jw-json-viwer-theme {
  background: var(--v-background-base);
  white-space: nowrap;
  color: var(--v-text-base);
  font-size: 14px;
  font-family: Consolas, Menlo, Courier, monospace;

  .jv-ellipsis {
    color: var(--v-label-base);
    background-color: var(--v-background-base);
    display: inline-block;
    line-height: 0.9;
    font-size: 0.9em;
    padding: 0px 4px 2px 4px;
    border-radius: 3px;
    vertical-align: 2px;
    cursor: pointer;
    user-select: none;
  }
  .jv-button { color: #49b3ff }
  .jv-key { color: var(--v-text-base) }
  .jv-item {
    &.jv-array { color: var(--v-text-base) }
    &.jv-boolean { color: #fc1e70 }
    &.jv-function { color: #067bca }
    &.jv-number { color: #fc1e70 }
    &.jv-number-float { color: #fc1e70 }
    &.jv-number-integer { color: #fc1e70 }
    &.jv-object { color: var(--v-text-base) }
    &.jv-undefined { color: #e08331 }
    &.jv-string {
      color: #42b983;
      word-break: break-word;
      white-space: normal;
    }
  }
  .jv-code {
    .jv-toggle {
      &:before {
        padding: 0px 2px;
        border-radius: 2px;
      }
      &:hover {
        &:before {
          background: var(--v-background-base);
        }
      }
    }
  }
}

</style>


<style lang="scss" scoped>
.content {
  min-height: calc(100% - 280px);
  padding-top: 32px;

  @media screen and (max-width: 700px) {
    padding-top: 24px;
  }

  @media screen and (max-width: 420px) {
    padding-top: 16px;
  }
}
.app-page {
  background-color: #0a0a0a !important;
  color: white;
  height: 100%;
  width: 100%;
  font-family: 'Sora-Regular', sans-serif !important;
  font-size: 20px;
}

.brandBox {
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  background: linear-gradient(180deg, rgba(36, 183, 58, 0.08) 0%, rgba(10, 10, 10, 0) 100%);
  padding-top: 20px;
  position: relative;
  animation: fadeIn 0.6s ease-out;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 80%;
    height: 1px;
    background: linear-gradient(90deg, transparent 0%, rgba(36, 183, 58, 0.3) 50%, transparent 100%);
  }

  .brandContainer {
    height: 270px;
    max-width: 900px;
    width: 80%;
    @media screen and (max-width: 920px) {
      width: 95%;
    }

    @media screen and (max-width: 700px) {
      height: 209px;
    }
    @media screen and (max-width: 420px) {
      height: 160px;
    }
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .logo {
      margin: 0px 23px 0px 13px;
      position: relative;

      .imgBrand {
        height: 180px;
        width: 180px;
        object-fit: cover;
        border-radius: 50%;
        border: 3px solid rgba(36, 183, 58, 0.3);
        box-shadow:
          0 4px 16px rgba(0, 0, 0, 0.3),
          0 0 0 8px rgba(36, 183, 58, 0.1);
        transition: all 0.3s ease;

        &:hover {
          transform: scale(1.05);
          border-color: rgba(36, 183, 58, 0.5);
          box-shadow:
            0 6px 24px rgba(0, 0, 0, 0.4),
            0 0 0 8px rgba(36, 183, 58, 0.15);
        }

        @media screen and (max-width: 700px) {
          height: 126px;
          width: 126px;
        }
        @media screen and (max-width: 420px) {
          height: 80px;
          width: 80px;
        }
      }
    }
    .textContainer {
      display: flex;
      justify-content: center;
      align-items: flex-start;
      flex-direction: column;
      .companyName {
        font-size: 26px;
        font-weight: 600;
        letter-spacing: -0.5px;
        margin-bottom: 8px;
        @media screen and (max-width: 420px) {
          font-size: 20px;
        }
      }
      .poweredBy {
        .poweredByImg {
          max-width: 188px;
          opacity: 0.85;
          transition: opacity 0.3s ease;

          &:hover {
            opacity: 1;
          }

          @media screen and (max-width: 420px) {
            max-width: 150px;
          }
        }
      }
    }
  }
}

</style>

















